module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Tools/Spatula-9d3574f9720cb6fdbaf053e89c845d78.svg";